export interface DataEntity_Main_03_01_Interface {
  id:number,
  calibration_id:number,
  filename:string,
  filename1:string,
  pdf_src:string,
  mapping:string,
  delivery_time:Number,
  manufacture:string,
  model:string,
  type:string,
  capability: string,

  unit_setPoint: string,
  unit_reference: string,
  unit_indication: string,

  unit_instability: string,
  unit_inhomogeneity: string,
  unit_correction: string,

  unit_correction_eqution: string,

  unit_uncertainty: string,
  unit_working: string,

  working_type:number,

   ////Mohit
   temperature_Air_before:string,
   temperature_Air_after:string,

   humidity_Air_before:string,
   humidity_Air_after:string,

   pressure_before:string,
   pressure_after:string,

  ///
  manufacture1:string,
  type1:string,
  model1:string,
  model2:string,
  code1:string,
  serial1:string,

}

export function Empty_DataEntity_Main_03_01_Interface():DataEntity_Main_03_01_Interface{
    return{
        id:0,
        calibration_id:0,
        filename:'',
        filename1:'',
        pdf_src:'',
        mapping:'',
        delivery_time: 0,
        manufacture:'',
        model:'',
        type:'',
        capability: '',

        unit_setPoint: '',
        unit_reference: '',
        unit_indication: '',

        unit_instability: '',
        unit_inhomogeneity: '',
        unit_correction: '',

        unit_correction_eqution: '',
        unit_uncertainty: '',
      unit_working: '',

      working_type:0,

        ////Mohit


        temperature_Air_before:'',
        temperature_Air_after:'',

        humidity_Air_before:'',
        humidity_Air_after:'',

        pressure_before:'',
        pressure_after: '',


        manufacture1:'',
        type1:'',
        model1:'',
        model2:'',
        code1:'',
        serial1:'',

    }
  }
